import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "filter",
    text: "Filtered view",
    iconColor: "white",
    listItemCustomStyle: { width: "180px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "service",
    text: "Service prioritization",
    iconColor: "white",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "ok",
    text: "Comprehensive fault \nvisibility",
    iconColor: "white",
    listItemCustomStyle: { width: "251px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "comprehensive-fault-visibility",
    text: "Quick response feature",
    iconColor: "white",
    listItemCustomStyle: { width: "auto" },
  },
];

const DATA_BENEFITS_IEAM_1 = {
  title: "Network Topology visualization",
  subtitle:
    "The network topology visualization provides a hierarchical \nview of the network",
  titleNumber: "2.",
  text: "\nProviding agents with an end-to-end network view enables them to understand \nthe root cause effectively.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "NEXT",
    onClick: () => setCurrentPage("ILO_204"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_202"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO2/ILO2_Introduction_03.png",
};

export default DATA_BENEFITS_IEAM_1;
